import React, {useEffect, useState} from "react";
import Loading from "./Loading";
import ResourceTile from "./ResourceTile";
import ResourceFilter from "./ResourceFilter";


const ResourcesPage = (props) => {

  const [init, setInit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [resources, setResources] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [resourceTypes, setResourceTypes] = useState([]);

  const [selectedDocumentType, setSelectedDocumentType] = useState(null);
  const [selectedProductCategory, setSelectedProductCategory] = useState(null);
  const [selectedResourceType, setSelectedResourceType] = useState(null);

  const {
    endpoint
  } = props;

  useEffect(() => {
    fetch(`${endpoint}/settings`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        setResourceTypes(data.resourceTypes);
        setDocumentTypes(data.documentTypes);
        setProductCategories(data.productCategories);
        setInit(true)
      });
  }, []);


  useEffect(() => {
    if (init) {
      setLoading(true);

      const params = new URLSearchParams({
        r: selectedResourceType ? selectedResourceType.id : 0,
        d: selectedDocumentType ? selectedDocumentType.id : 0,
        c: selectedProductCategory ? selectedProductCategory.id : 0,
      });

      fetch(`${endpoint}/feed?${params.toString()}`)
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          setResources(data.resources);
          setLoading(false)
        });
    }
  }, [init, selectedDocumentType, selectedResourceType, selectedProductCategory]);

  // if (!init) {
  //   return <div>
  //     <Loading />
  //   </div>
  // }


  return <div className="resourcesPage">
    <div className="container">
      <div className="resourcesPage__wrapper">
        <div className="resourcesPage__left">
          <div className="resourcesPage__left__wrapper">
            <div className="resourcesPage__left__title">
              <h5>Filter</h5>
            </div>
            <div className="resourcesPage__filters">
              <ResourceFilter
                title={'Type of resource'}
                options={resourceTypes}
                onSelected={setSelectedResourceType}
              />
              <ResourceFilter
                title={'Product Category'}
                options={productCategories}
                onSelected={setSelectedProductCategory}
              />
              <ResourceFilter
                title={'Document Type'}
                options={documentTypes}
                onSelected={setSelectedDocumentType}
              />

            </div>
          </div>
        </div>
        <div className="resourcesPage__right">
          <div className="resourcePage__right__wrapper">
            {!!loading && <>
              <Loading />
            </>}
            {!loading && <>
              {resources.length > 0 && <>
                {resources.map((resource, index) => {
                  return <ResourceTile resource={resource} key={index}/>
                })}
              </>}
              {resources.length === 0 && <>
                <p>No matching resources found.</p>
              </>}
            </>}
          </div>
        </div>
      </div>
    </div>

  </div>

}

export default ResourcesPage;
